import moment from 'moment-timezone';
import DatePicker from 'vue2-datepicker';
import custom from '@/custom';
import codes from '@/codes';
// import { Switch as cSwitch } from '@coreui/vue';

//restful api
import { policy as wmds } from '@/service/api/wmds'

const i18n_fields = {
  EN: [
    { key: 'id', label: '#.', sortable: false, thStyle: 'width: 10%' },
    { key: 'created_at', label: 'Registed_at', sortable: false },
    { key: 'group', label: 'Group', sortable: false },
    { key: 'count', label: 'Using Site', sortable: false },
    { key: 'description', label: 'Description', sortable: false },
    { key: 'policy', label: 'Max Page', sortable: false },
    { key: 'updated_at', label: 'Last Modify', sortable: false },
  ],
  KO: [
    { key: 'id', label: '#.', sortable: false, thStyle: 'width: 10%' },
    { key: 'created_at', label: '등록일', sortable: false },
    { key: 'group', label: '그룹', sortable: false },
    { key: 'count', label: '사용중인 사이트', sortable: false },
    { key: 'description', label: '정책명', sortable: false },
    { key: 'policy', label: '최대 페이지', sortable: false },
    { key: 'updated_at', label: '마지막 점검일', sortable: false },
  ]
}


export default {
  props: ['item', 'use_view'],
  components: { DatePicker },
  data: () => { return { codes, so : Object.assign({}, codes.DEFAULT_OPT, { sk : '' }), custom, hide: true } },
  computed: {
    fields : function() {
      return i18n_fields[this.i18n];
    },
    rowCount: function() { return this.so.totalRows || 0; },
    startRow : function() { return this.so.totalRows - (this.so.currentPage - 1) * this.so.perPage; }
  },
  methods: {
    search_opt() {
      this.so.adv = !this.so.adv;
      if(this.so.adv) {
        this.so.opt['created_at_ed'] = moment().add(1, "day");
        this.so.opt['updated_at_ed'] = moment().add(1, "day");
        this.so.opt['match_type'] = 'and';
        this.so.sv = ''
      } else { this.reset(); }
    },
    set_op(k, v) {
      return { name : k, value : `%${v}%`, op : 'like' }
    },
    set_sd(v, k = 'created_at') {
      let opt = this.so.opt;

      if(!v) { delete opt[`${k}_sd`]; delete opt[`${k}_ed`]; }
      else {
        let ed = opt[`${k}_ed`] || moment().startOf('d');
        let sd = opt[`${k}_sd`] || ed;
        switch(v) {
          // case '+1d' : sd = moment(sd).subtract(-1, 'd'); break;
          case '-1d' : sd = moment(sd).subtract(1, 'd'); break;
          case '-1w' : sd = moment(sd).subtract(1, 'w'); break;
          case '-1m' : sd = moment(sd).subtract(1, 'M'); break;
          case 'w' : sd = moment(ed).startOf('isoweek'); break;
          case 'm' : sd = moment(ed).startOf('month'); break;
        }
        opt[`${k}_sd`] = sd.format('YYYY-MM-DD');
      }
      this.so.opt = Object.assign({}, this.so.opt, opt);
    },
    reset() { this.so = Object.assign({}, codes.DEFAULT_OPT, { sk : '', sv : '' }); this.refresh(); },
    refresh() { this.$refs._list.refresh(); },
    getItems: function(ctx) { return this.load(ctx); },
    // getItems: function() {return this.list()},
    load(ctx = {}) {
        let so = {
          body : {
            sort : [{ name : "id", op : "desc" }, { name : "is_del", op : "desc"}],
            or : [],
            and : []
          },
          offset : (this.so.currentPage-1 || 0) * Number(this.so.perPage), limit: Number(this.so.perPage), // 10 은 나중에 변수 처리해야함.
        }

        if(ctx.sortBy) { so.body.sort = [ { name : ctx.sortBy, op : !ctx.sortDesc && 'desc' } ]; }
        if(this.group) { so.body.and.push({ name : 'group_id', value : this.group.id, op : '='}) }
        if(this.so.sv) { so.body.and.push(this.set_op('description', this.so.sv, so)); }
        if(this.hide) { so.body.and.push({ name : 'is_del', value : false, op : '=' });}

        if(this.so.adv && this.so.opt) {
          var k = Object.keys(this.so.opt)
          for (let i = 0; i < k.length; i++) {
            if(k[i] == 'match_type') { continue; }
            let cond = undefined;

            switch (k[i]) {
              case 'created_at_sd':
                if(!this.so.opt[k[i]]) { this.$toastr.w("start Time is require", "notice"); break; }
                cond = { name : k[i].slice(0, 10), value : moment(this.so.opt[k[i]]).format("YYYY-MM-DD"), op : ">=" }
                break;
              case 'created_at_ed':
                if(!this.so.opt[k[i]]) { this.$toastr.w("end Time is require", "notice"); break; }
                cond = { name : k[i].slice(0, 10), value : moment(this.so.opt[k[i]]).format("YYYY-MM-DD"), op : "<" }
                break;
              case 'updated_at_sd':
                if(!this.so.opt[k[i]]) { this.$toastr.w("start Time is require", "notice"); break; }
                cond = { name : k[i].slice(0, 10), value : moment(this.so.opt[k[i]]).format("YYYY-MM-DD"), op : ">=" }
                break;
              case 'updated_at_ed':
                if(!this.so.opt[k[i]]) { this.$toastr.w("end Time is require", "notice"); break; }
                cond = { name : k[i].slice(0, 10), value : moment(this.so.opt[k[i]]).format("YYYY-MM-DD"), op : "<" }
                break;
              default:
                cond = this.set_op(k[i], this.so.opt[k[i]]);
                break;
            }
            if(cond.value == '%%' || cond.value === '') { continue; }
            if(this.so.opt['match_type'] == "and") { so.body.and.push(cond) }
            else { so.body.or.push(cond) }
          }
        }
      return wmds.listPolicy(so).then(rs => { this.so.totalRows = rs.total; return rs.body ? rs.body : []; })
        .catch(e => this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText))
    },
    detail: function(item) {
      this.use_view != false ? this.$router.push({ name : 'wmds_policy', params : { id : item.id } }) : this.$emit('selected', item);
    },

    //is_del : false 인 데이터만 보여주기
    // list(){
    //   this.sk = 'is_del'
    //   this.sv = ""
    //   let value = "false"
    //   this.sv = Boolean(!value)
    //   // this.so = Object.assign({}, { sk : this.sk, sv : this.sv });
    //   let so = {
    //       target : 'wmds.policy', cmd : 'list',
    //       body : {
    //         sort : [{ name : "this.so.sk", op : "desc" }],
    //         or : [],
    //         and : []
    //       },
    //       offset : (this.so.currentPage-1 || 0) * Number(this.so.perPage), limit: Number(this.so.perPage), // 10 은 나중에 변수 처리해야함.
    //     }
    //     if(this.so.sk) { so.body.sort = [ { name : this.so.sk, op : 'desc' } ]; }
    //     if(this.so.sv && this.so.sk) { so.body.and.push(this.set_op(this.so.sk, this.so.sv, so)); }
    //     return Api.Manager(so).then(rs => { this.so.totalRows = rs.total; return rs.body ? rs.body : []; })
    //     .catch(e => this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText))
    // }
  },
  // watch: { '$route' (to, from) { this.$on('refresh', this.refresh()) } },
  created: function() { console.log('pattern.vue', 'created'); },
  destroyed: function() { console.log('pattern.vue', 'destroyed'); },
  mounted: function() { 
    console.log('pattern.vue', 'mounted');
  },
}